// src/index.tsx
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { RecoilRoot } from 'recoil';
import App from './App';
import { Authenticator } from '@aws-amplify/ui-react';
import { Amplify, Logger } from 'aws-amplify';
import { cognitoConfig, publicAgentApiEndpoint } from './endpoints';

// Side-effect stylesheet imports (typed via src/types/static-assets.d.ts)
import '@aws-amplify/ui-react/styles.css';
import './index.css';
import './prism.css';

// Prism core + languages
import 'prismjs';
import 'prismjs/components/prism-graphql';
import 'prismjs/components/prism-json';

// 🔊 Set Amplify logger level here. Use 'WARN' in prod; 'DEBUG' only while tracing.
Logger.LOG_LEVEL = 'WARN';

// ⚙️ Amplify config: we only use API.graphql() for SUBSCRIPTIONS over the PUBLIC endpoint.
// All queries/mutations go through the private /graphql proxy via GraphqlQuery.
Amplify.configure({
  Auth: {
    region: cognitoConfig.region,
    userPoolId: cognitoConfig.userPoolId,
    userPoolWebClientId: cognitoConfig.userPoolClientId,
    oauth: {
      domain: cognitoConfig.userPoolDomain,
      scope: ['email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
      redirectSignIn: cognitoConfig.userPoolRedirectSignInUri,
      redirectSignOut: cognitoConfig.userPoolRedirectSignOutUri,
      responseType: 'code',
      responseMode: 'query'
    }
  },
  API: {
    aws_appsync_graphqlEndpoint: publicAgentApiEndpoint, // <- PUBLIC WS for subscriptions
    aws_appsync_region: cognitoConfig.region,
    aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS'
  }
});

// Tiny beacon so you can confirm bundle & endpoint at runtime
console.log('[index] Amplify configured for subscriptions only', {
  publicAgentApiEndpoint,
  region: cognitoConfig.region,
  LOG_LEVEL: Logger.LOG_LEVEL
});

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <RecoilRoot>
    <BrowserRouter>
      <Authenticator.Provider>
        <App />
      </Authenticator.Provider>
    </BrowserRouter>
  </RecoilRoot>
);
